// paypal.js

export const types = {
  READY: 'PAYPAL.READY',
  PAYMENT_PENDING: 'PAYPAL.PAYMENT_PENDING',
  FAILED: 'PAYPAL.FAILED',
  COMPLETE: 'PAYPAL.COMPLETE',
  SET_CREDITS: 'PAYPAL.SET_CREDITS',
  BUTTON_CLICK: 'PAYPAL.BUTTON_CLICK'
};

export const ready = () => ({
  type: types.READY
});

export const paymentPending = () => ({
  type: types.PAYMENT_PENDING
});

export const failed = () => ({
  type: types.FAILED
});

export const complete = () => ({
  type: types.COMPLETE
});

export const setCredits = creditsPackage => ({
  type: types.SET_CREDITS,
  creditsPackage
});

export const buttonClick = msg => ({
  type: types.BUTTON_CLICK,
  msg
});



// WEBPACK FOOTER //
// ./src/store/actions/paypal.js